import * as Raven from 'raven-js';
import * as Api from './Api';
import * as Routes from './Routes';
import * as Vouchers from './Vouchers';

export class Item {
  public Item: Api.MenuItem;
  public Options: Api.MenuItemOptionSetItem[];
}

export interface Data {
  items: Item[];
  requestedTime: string;
  voucher: Vouchers.States;
  menuId: number;
}

export const Empty: Data = {
  items: [],
  requestedTime: '',
  voucher: Vouchers.Default,
  menuId: 0
};

export const CurrencySymbols = function(key: Api.Currency): string {
  switch (key) {
    case Api.Currency.AED:
      return 'د.إ';
    case Api.Currency.AFN:
      return '؋';
    case Api.Currency.ALL:
      return 'L';
    case Api.Currency.AMD:
      return '֏'; //case Api.Currency.ANG: return 'ƒ'; //case Api.Currency.AOA: return 'Kz';
    case Api.Currency.ARS:
      return '$';
    case Api.Currency.AUD:
      return '$'; //case Api.Currency.AWG: return 'ƒ';
    case Api.Currency.AZN:
      return 'ман';
    case Api.Currency.BAM:
      return 'KM'; //case Api.Currency.BBD: return '$';
    case Api.Currency.BDT:
      return '৳';
    case Api.Currency.BGN:
      return 'лв';
    case Api.Currency.BHD:
      return '.د.ب'; //case Api.Currency.BIF: return 'FBu';
    case Api.Currency.BMD:
      return '$';
    case Api.Currency.BND:
      return '$';
    case Api.Currency.BOB:
      return '$b';
    case Api.Currency.BRL:
      return 'R$'; //case Api.Currency.BSD: return '$';
    case Api.Currency.BTN:
      return 'Nu.';
    case Api.Currency.BWP:
      return 'P'; //case Api.Currency.BYR: return 'Br.';
    case Api.Currency.BZD:
      return 'BZ$';
    case Api.Currency.CAD:
      return '$';
    case Api.Currency.CDF:
      return 'Fr.';
    case Api.Currency.CHF:
      return 'CHF';
    case Api.Currency.CLP:
      return '$';
    case Api.Currency.CNY:
      return '¥';
    case Api.Currency.COP:
      return '$';
    case Api.Currency.CRC:
      return '₡';
    case Api.Currency.CUP:
      return '₱'; //case Api.Currency.CUC: return '$'; //case Api.Currency.CVE: return 'Esc';
    case Api.Currency.CZK:
      return 'Kč';
    case Api.Currency.DJF:
      return 'Fdj';
    case Api.Currency.DKK:
      return 'kr';
    case Api.Currency.DOP:
      return 'RD$';
    case Api.Currency.DZD:
      return 'د.ج'; //case Api.Currency.EEK: return 'kr';
    case Api.Currency.EGP:
      return '£';
    case Api.Currency.ERN:
      return 'Nfk';
    case Api.Currency.ETB:
      return 'Br.';
    case Api.Currency.EUR:
      return '€'; //case Api.Currency.FJD: return '$'; //case Api.Currency.FKP: return '£';
    case Api.Currency.GBP:
      return '£';
    case Api.Currency.GEL:
      return 'ლ'; //case Api.Currency.GGP: return '£'; //case Api.Currency.GHS: return '₵'; //case Api.Currency.GIP: return '£'; //case Api.Currency.GMD: return 'D'; //case Api.Currency.GNF: return 'GFr';
    case Api.Currency.GTQ:
      return 'Q'; //case Api.Currency.GYD: return '$';
    case Api.Currency.HKD:
      return '$';
    case Api.Currency.HNL:
      return 'L';
    case Api.Currency.HRK:
      return 'kn';
    case Api.Currency.HTG:
      return 'G';
    case Api.Currency.HUF:
      return 'Ft';
    case Api.Currency.IDR:
      return 'Rp';
    case Api.Currency.ILS:
      return '₪'; //case Api.Currency.IMP: return '£';
    case Api.Currency.INR:
      return '₹';
    case Api.Currency.IQD:
      return 'ع.د';
    case Api.Currency.IRR:
      return '﷼';
    case Api.Currency.ISK:
      return 'kr'; //case Api.Currency.JEP: return '£';
    case Api.Currency.JMD:
      return 'J$';
    case Api.Currency.JOD:
      return 'د.ا';
    case Api.Currency.JPY:
      return '¥';
    case Api.Currency.KES:
      return 'Sh';
    case Api.Currency.KGS:
      return 'лв';
    case Api.Currency.KHR:
      return '៛'; //case Api.Currency.KMF: return 'CF'; //case Api.Currency.KPW: return '₩';
    case Api.Currency.KRW:
      return '₩';
    case Api.Currency.KWD:
      return 'د.ك'; //case Api.Currency.KYD: return '$';
    case Api.Currency.KZT:
      return '₸';
    case Api.Currency.LAK:
      return '₭';
    case Api.Currency.LBP:
      return 'ل.ل';
    case Api.Currency.LKR:
      return 'රු'; //case Api.Currency.LRD: return '$'; //case Api.Currency.LSL: return 'L'; //case Api.Currency.LTL: return 'Lt'; //case Api.Currency.LVL: return 'Ls';
    case Api.Currency.LYD:
      return 'ل.د';
    case Api.Currency.MAD:
      return 'د.م.';
    case Api.Currency.MDL:
      return 'L'; //case Api.Currency.MGA: return 'Ar';
    case Api.Currency.MKD:
      return 'ден';
    case Api.Currency.MMK:
      return 'Ks';
    case Api.Currency.MNT:
      return '₮';
    case Api.Currency.MOP:
      return 'P'; //case Api.Currency.MRO: return 'UM'; //case Api.Currency.MUR: return '₨';
    case Api.Currency.MVR:
      return '.ރ'; //case Api.Currency.MWK: return 'MK';
    case Api.Currency.MXN:
      return '$';
    case Api.Currency.MYR:
      return 'RM'; //case Api.Currency.MZN: return 'MT'; //case Api.Currency.NAD: return '$';
    case Api.Currency.NGN:
      return '₦';
    case Api.Currency.NIO:
      return 'C$';
    case Api.Currency.NOK:
      return 'kr';
    case Api.Currency.NPR:
      return '₨';
    case Api.Currency.NZD:
      return '$';
    case Api.Currency.OMR:
      return 'ر.ع.';
    case Api.Currency.PAB:
      return 'B/.';
    case Api.Currency.PEN:
      return 'S/.'; //case Api.Currency.PGK: return 'K';
    case Api.Currency.PHP:
      return '₱';
    case Api.Currency.PKR:
      return '₨';
    case Api.Currency.PLN:
      return 'zł'; //case Api.Currency.PRB: return 'p.';
    case Api.Currency.PYG:
      return '₲';
    case Api.Currency.QAR:
      return 'ر.ق';
    case Api.Currency.RON:
      return 'lei';
    case Api.Currency.RSD:
      return 'Дин.';
    case Api.Currency.RUB:
      return 'руб';
    case Api.Currency.RWF:
      return 'R₣';
    case Api.Currency.SAR:
      return 'ر.س'; //case Api.Currency.SBD: return '$'; //case Api.Currency.SCR: return '₨'; //case Api.Currency.SDG: return '£';
    case Api.Currency.SEK:
      return 'kr';
    case Api.Currency.SGD:
      return '$'; //case Api.Currency.SHP: return '£'; //case Api.Currency.SLL: return 'Le';
    case Api.Currency.SOS:
      return 'Sh'; //case Api.Currency.SRD: return '$'; //case Api.Currency.SSP: return '£'; //case Api.Currency.STD: return 'Db'; //case Api.Currency.SVC: return '$';
    case Api.Currency.SYP:
      return 'ل.س'; //case Api.Currency.SZL: return 'L';
    case Api.Currency.THB:
      return '฿';
    case Api.Currency.TJS:
      return 'SM';
    case Api.Currency.TMT:
      return 'm';
    case Api.Currency.TND:
      return 'د.ت'; //case Api.Currency.TOP: return 'T$';
    case Api.Currency.TRY:
      return '₺';
    case Api.Currency.TTD:
      return 'TT$';
    case Api.Currency.TWD:
      return 'NT$'; //case Api.Currency.TZS: return 'Sh';
    case Api.Currency.UAH:
      return '₴'; //case Api.Currency.UGX: return 'Sh';
    case Api.Currency.USD:
      return '$';
    case Api.Currency.UYU:
      return '$U';
    case Api.Currency.UZS:
      return 'лв';
    case Api.Currency.VEF:
      return 'Bs';
    case Api.Currency.VND:
      return '₫'; //case Api.Currency.VUV: return 'Vt'; //case Api.Currency.WST: return 'T';
    case Api.Currency.XAF:
      return '#'; //case Api.Currency.XAG: return '#'; //case Api.Currency.XAU: return '#'; //case Api.Currency.XBA: return '#'; //case Api.Currency.XBB: return '#'; //case Api.Currency.XBC: return '#'; //case Api.Currency.XBD: return '#';
    case Api.Currency.XCD:
      return '$';
    case Api.Currency.XDR:
      return '#'; //case Api.Currency.XFU: return '#';
    case Api.Currency.XOF:
      return '#'; //case Api.Currency.XPD: return '#'; //case Api.Currency.XPF: return '#'; //case Api.Currency.XPT: return '#';
    case Api.Currency.YER:
      return '﷼';
    case Api.Currency.ZAR:
      return 'R'; //case Api.Currency.ZMW: return 'ZK'; //case Api.Currency.ZWD: return '#';//
  }

  Raven.captureMessage('Cannot find currnecy symbol for ' + key);
  return '#';
};

const sum = (a: number, b: number): number => a + b;

// TODO - this function is easy to unit test.
export const MaximumPrice = (item: Api.MenuItem): number => {
  const { Price, MenuItemOptionSets } = item;
  const maxPrice = (optionSet: Api.MenuItemOptionSet): number => {
    const { MaxSelectCount, MenuItemOptionSetItems } = optionSet;
    const prices = MenuItemOptionSetItems.map((i) => i.Price);
    const expensiveFirst = prices.sort((a, b) => b - a);
    const mostExpensiveOptions = expensiveFirst.slice(0, MaxSelectCount);
    return mostExpensiveOptions.reduce(sum, 0);
  };
  return Price + MenuItemOptionSets.map(maxPrice).reduce(sum, 0);
};

export const ItemTotal = function(item: Item): number {
  return item.Item.Price + item.Options.map((it) => it.Price).reduce(sum, 0);
};

export const Total = function(items: Item[]): number {
  return items.map(ItemTotal).reduce(sum, 0);
};

export const ToCurrency = function(price: number, currency: Api.Currency, lang: string) {
  switch (currency) {
    case Api.Currency.AED: {
      const formatter = new Intl.NumberFormat(lang || 'en', {
        minimumFractionDigits: 2
      });
      return CurrencySymbols(currency) + formatter.format(price);
    }

    case Api.Currency.BMD: {
      // Intl.NumberFormat doesn't contain currency symbol... legends says they using '$'
      const formatter = new Intl.NumberFormat(lang || 'en', {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2
      });
      return formatter.format(price);
    }

    default: {
      const formatter = new Intl.NumberFormat(lang || 'en', {
        style: 'currency',
        currency: Api.Currency[currency] || 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(price);
    }
  }
};

export const CardFees = function(total: number, fees: Api.CardFees): number {
  if (!fees) {
    Raven.captureMessage('null card fees - cannot compute fee');
    return 0;
  }
  const fee =
    fees.FixedFeeCardOrdersChargedToCustomerIncludingVat +
    (total * fees.PercentFeeCardOrdersChargedToCustomerIncludingVat) / 100;
  return fee;
};

export const CashFees = function(total: number, fees: Api.CashFees): number {
  if (!fees) {
    Raven.captureMessage('null cash fees - cannot compute fee');
    return 0;
  }
  const fee =
    fees.FixedFeeCashOrdersChargedToCustomerIncludingVat +
    (total * fees.PercentFeeCashOrdersChargedToCustomerIncludingVat) / 100;
  return isNaN(fee) ? 0 : fee;
};

export const VoucherTotal = (basket: Data): number => {
  if (basket.voucher.status != 'valid') {
    return 0;
  }
  return basket.voucher.items.map((i) => i.Amount).reduce(sum);
};

export const BasketToOrder = (
  deviceId: string,
  location: Api.Geo,
  basket: Data,
  route: Routes.Routes,
  MenuId: number,
  VersionGuid: string,
  tableNumber: string,
  PickupLocationType: Api.PickupLocationType
): Api.DeliveryOrder | Api.CollectionOrder => {
  const items: Api.OrderItem[] = basket.items.map((item: Item) => {
    return {
      MenuItemId: item.Item.MenuItemId,
      MenuItemOptionSetItemIds: item.Options.map((option) => option.MenuItemOptionSetItemId)
    };
  });

  const orderBase = {
    VirtualRestaurantId: route.params.vrid,
    deviceId,
    OrderItemVms: items,
    TipAmount: 0,
    RequestedDeliveryOrPickupTimeUtc: basket.requestedTime,
    MenuId,
    VersionGuid
  };

  switch (route.params.type) {
    case 'collection':
      if (tableNumber != '') {
        return {
          ...orderBase,
          DeliveryType: Api.DeliveryType.Collection,
          PhysicalRestaurantId: route.params.id,
          PickupLocationType: PickupLocationType,
          PickupLocationId: parseInt(tableNumber)
        };
      } else {
        return {
          ...orderBase,
          DeliveryType: Api.DeliveryType.Collection,
          PickupLocationType: PickupLocationType,
          PhysicalRestaurantId: route.params.id
        };
      }

    case 'delivery':
      return {
        ...orderBase,
        DeliveryType: Api.DeliveryType.Delivery,
        DeliveryLocationId: route.params.id,
        UserLocation: location
      };
  }
};
